module.exports = __webpack_public_path__ + "static/media/fist_green.04c3ae37.svg";


//////////////////
// WEBPACK FOOTER
// ./src/res/img/fist_green.svg
// module id = 132
// module chunks = 0